module.exports = __webpack_public_path__ + "static/media/zr_2_14.3ae43956.png";